module.exports = __webpack_public_path__ + "img/private.4b934eec.svg";